var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;clip-path:url(#SVGID_00000183927182262308905020000008841902341806360202_);}\n\t.st3{fill:#FF669B;}\n\t.st4{clip-path:url(#SVGID_00000050639508068646320070000010155072580088857523_);}\n\t.st5{fill:none;stroke:#FF669B;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012453483901866929730000017679064253718670208_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000012453483901866929730000017679064253718670208_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9c2.4,2.4,5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2 c0.8-0.8,1.2-1.9,1.2-3s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 c-0.8,0.8-1.2,1.9-1.2,3v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000007405521856300377780000002631872697689936819_",
    x: 4.2,
    y: 3.7,
    width: 94.5,
    height: 94.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183245233520061279080000018156980028215459990_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007405521856300377780000002631872697689936819_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183245233520061279080000018156980028215459990_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.7,12.3c-2.2-1.9-4.8-3.2-7.6-3.9c-2.8-0.7-5.7-0.8-8.5-0.3l-15.1,2.7c-3.5,0.6-6.6,2.4-9,5.1 c-2.3-2.7-5.5-4.4-9-5.1L27.5,8c-2.8-0.5-5.8-0.4-8.6,0.3c-2.8,0.7-5.4,2.1-7.6,3.9c-2.2,1.8-4,4.2-5.2,6.8 c-1.2,2.6-1.9,5.5-1.9,8.3v42.5c0,4.6,1.6,9.1,4.6,12.6c3,3.5,7.1,5.9,11.6,6.8l24.8,4.5c4.2,0.8,8.5,0.8,12.7,0l24.8-4.5 c4.5-0.8,8.6-3.2,11.6-6.8c2.9-3.5,4.6-8,4.6-12.6V27.4c0-2.9-0.6-5.7-1.9-8.3C95.7,16.4,93.9,14.1,91.7,12.3z M47.6,86.2 c-0.3,0-0.7-0.1-1-0.2l-24.8-4.5c-2.7-0.5-5.2-1.9-7-4.1c-1.8-2.1-2.7-4.8-2.7-7.6V27.4c0-3.1,1.2-6.1,3.5-8.4 c2.2-2.2,5.2-3.5,8.4-3.5c0.7,0,1.4,0.1,2.1,0.2l15,2.8c1.8,0.3,3.4,1.3,4.6,2.7c1.2,1.4,1.8,3.2,1.8,5V86.2z M90.9,69.9 c0,2.8-1,5.4-2.7,7.6c-1.8,2.1-4.2,3.6-7,4.1L56.4,86c-0.3,0.1-0.7,0.1-1,0.2V26.2c0-1.8,0.6-3.6,1.8-5c1.2-1.4,2.8-2.4,4.6-2.7 l15-2.8c1.7-0.3,3.5-0.2,5.1,0.2c1.7,0.4,3.2,1.2,4.6,2.4c1.3,1.1,2.4,2.5,3.1,4.1c0.7,1.6,1.1,3.3,1.1,5V69.9z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 63.2,
    y1: 34,
    x2: 85.2,
    y2: 30.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 63.2,
    y1: 50.7,
    x2: 85.2,
    y2: 46.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 63.2,
    y1: 67.3,
    x2: 85.2,
    y2: 63.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferences);
export default __webpack_public_path__ + "static/media/References.2687f298be7f6f4e822606055730c38c.svg";
export { ForwardRef as ReactComponent };